var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#BCBCC6",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.229 12.1996C20.9082 11.5934 23.711 12.4041 25.6528 14.347C25.6602 14.3543 25.6677 14.3616 25.6753 14.3688L28.4755 17H25C24.4477 17 24 17.4477 24 18C24 18.5523 24.4477 19 25 19H30.993C31.0131 19.0001 31.0332 18.9997 31.0533 18.9986C31.1579 18.9931 31.2583 18.9715 31.352 18.9363C31.4909 18.8842 31.6204 18.8002 31.7288 18.6848C31.9133 18.4885 32.0031 18.2374 32 17.9877V12C32 11.4477 31.5523 11 31 11C30.4477 11 30 11.4477 30 12V15.6881L27.056 12.9217C24.6291 10.5014 21.1314 9.49238 17.7877 10.2489C14.4388 11.0067 11.7128 13.4295 10.5674 16.6664C10.3831 17.1871 10.6558 17.7585 11.1765 17.9427C11.6971 18.127 12.2685 17.8543 12.4528 17.3336C13.3691 14.7441 15.5499 12.8058 18.229 12.1996Z",
    fill: "#BCBCC6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.3118V28C10 28.5523 9.55228 29 9 29C8.44772 29 8 28.5523 8 28V22C8 21.6992 8.13284 21.4294 8.34307 21.246C8.40965 21.1879 8.48224 21.14 8.55873 21.1024C8.69182 21.0368 8.84161 21 9 21H15C15.5523 21 16 21.4477 16 22C16 22.5523 15.5523 23 15 23H11.5246L14.3248 25.6313C14.3325 25.6384 14.34 25.6457 14.3473 25.6531C16.2892 27.5959 19.092 28.4066 21.7711 27.8004C24.4502 27.1942 26.631 25.2559 27.5473 22.6664C27.7316 22.1458 28.303 21.8731 28.8237 22.0573C29.3443 22.2415 29.617 22.813 29.4328 23.3336C28.2874 26.5705 25.5614 28.9934 22.2125 29.7511C18.8688 30.5077 15.371 29.4986 12.9442 27.0783L10 24.3118Z",
    fill: "#BCBCC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.7003b1989cea11a609a5a466e635dd3a.svg";
export { ForwardRef as ReactComponent };